import BSHtmlBaseBTStrategy from './BSHtmlBaseBTStrategy'

export default function BSHtmlBTWithAmountStrategy() {}

BSHtmlBTWithAmountStrategy.prototype = new BSHtmlBaseBTStrategy()

BSHtmlBTWithAmountStrategy.prototype.addFirstHeaderRowCells = function(row /*, levelsNumber*/) {
    this.addCreatedCell(row, this.createBillableCell(1, "moneyType"))
}

BSHtmlBTWithAmountStrategy.prototype.getLevelsNumber = function() {
    return 2
}

BSHtmlBTWithAmountStrategy.prototype.getColspan = function() {
    return 2
}

BSHtmlBTWithAmountStrategy.prototype.createSpentCell = function(row, rowSpan) {
    return ReportPreviewUtils.createCell(this.message("report.billing_summary.spent"), "spentTime", 1, rowSpan)
}

BSHtmlBTWithAmountStrategy.prototype.createAmountCell = function(row, rowSpan) {
    return ReportPreviewUtils.createCell(this.message("report.billing_summary.amount"), "subAmount", 1, rowSpan)
}

BSHtmlBTWithAmountStrategy.prototype.addSecondHeaderRowCells = function(row, levelsNumber) {
    const rowSpan = levelsNumber - 1

    this.addCreatedCell(row, this.createSpentCell(rowSpan))
    this.addCreatedCell(row, this.createAmountCell(rowSpan))
}

BSHtmlBTWithAmountStrategy.prototype.addColumnValueCells = function(row) {
    this.addTimeValueCell(row)
    this.addMoneyValueCell(row, "darkMoneyValueCell")
}


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/billingsummary/BSHtmlBTWithAmountStrategy.js